define('home/models/activities/ThreadActivity',[
    'underscore',
    'home/models/Activity',
    'home/activityExpander',
], function (
    _,
    Activity,
    activityExpander
) {
    'use strict';

    /**
     * Base class for activities that have thread targets
     */
    return Activity.extend({
        initialize: function (attributes) {
            this.target = attributes.target;
            this.thread = this.target;
            this.targetChannel = attributes.targetChannel;
        },

        parseRelatedModels: function (attributes, objects) {
            if (attributes.target && attributes.type === 'TrendingThreadOnChannel')
                attributes.targetChannel = activityExpander.buildChannel(objects, attributes.target);

            attributes.target = activityExpander.buildThread(objects, attributes.object);
            var thread = attributes.thread = attributes.target;

            // Parse selected (curated) post if present
            if (attributes.selectedPost) {
                var excerpt = attributes.selectedPost.excerpt;
                attributes.selectedPost = activityExpander.buildPost(objects, attributes.selectedPost.post);
                attributes.selectedPost.set({ excerpt: excerpt });
            }

            // Augment the thread with recent comments, if any, passed through the activity
            thread.initializeRecentPosts({
                recentPosts: _.map(attributes.recentPosts,
                    _.bind(activityExpander.buildPost, activityExpander, objects)
                ),
            });

            return attributes;
        },
    });
});

